"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SalesByProductConnection_1 = __importDefault(require("../entity/SalesByProductConnection"));
const SalesByProductEdgeStub_1 = __importDefault(require("./SalesByProductEdgeStub"));
const PageInfoStub_1 = __importDefault(require("./PageInfoStub"));
class SalesByProductConnectionStub extends SalesByProductConnection_1.default {
    constructor({ edges = [new SalesByProductEdgeStub_1.default(), new SalesByProductEdgeStub_1.default()], pageInfo = new PageInfoStub_1.default(), } = {}) {
        super({ edges, pageInfo });
    }
}
exports.default = SalesByProductConnectionStub;
